export default "__VITE_ASSET__CIAGxxvu__"